import { Box, Container } from "@mui/material";
import MetaTags from "react-meta-tags";

import LoginForm from "components/auth/LoginForm";
import { HeroText } from "components/shared/Typography";
import { LOGIN_TITLE, LOGIN_LINK_CANONICAL } from "helpers/metatags";

const Login = () => {
  return (
    <Box width={1}>
      <MetaTags>
        <title>{LOGIN_TITLE}</title>
        <link rel="canonical" href={LOGIN_LINK_CANONICAL} />
      </MetaTags>
      <Container>
        <Box px={{ xs: 0, sm: 3 }} pt={{ xs: 3, md: 4, lg: 5 }} pb={0}>
          <HeroText letterSpacing={0.25}>Welcome to Assay Marketplace</HeroText>
        </Box>
        <Box px={{ xs: 0, sm: 3 }} py={{ xs: 3, md: 4, lg: 5 }}>
          <LoginForm />
        </Box>
      </Container>
    </Box>
  );
};

export default Login;
